/**
 * SCD Lot 0 — Catalogue d'appels d'offres B2B transport (SCD) vidé.
 * Exports conservés pour compatibilité avec tenderHelpers / tenderSlice.
 */
export const TENDERS = [];

export const TENDER_TIER_RANK = { local: 1, regional: 2, national: 3 };

/**
 * Returns the senior-most commercial level the player has hired.
 */
export function getPlayerCommercialLevel(hiredSupport = {}) {
  if (hiredSupport['role-sylvie-marchand']) return 'expert';
  if (hiredSupport['role-marc-dupuis']) return 'senior';
  if (hiredSupport['role-lea-bertrand']) return 'junior';
  return null;
}

/**
 * Cross-walks the commercial level to the highest tender tier accessible.
 */
export function getMaxAccessibleTier(commercialLevel) {
  if (commercialLevel === 'expert') return 'national';
  if (commercialLevel === 'senior') return 'regional';
  if (commercialLevel === 'junior') return 'local';
  return null;
}
